import { render, staticRenderFns } from "./clientFilter.vue?vue&type=template&id=4ba9bea8"
import script from "./clientFilter.vue?vue&type=script&lang=js"
export * from "./clientFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports